import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { GetInvoice } from '../../services/InvoiceService';
import InvoiceOverView from './InvoiceOverView';
import ViewTransaction from './ViewTransaction';
import CommonLoader from '../common/CommonLoader';
import { Typography, Divider } from "@mui/material";
import { NotificationManager } from 'react-notifications';
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconButton, Tooltip } from "@mui/material";
import InvoiceTransactionsTable from "./InvoiceTransactionsTable";

const ViewInvoice = () => {

  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const { invoiceNumber } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getInvoice(invoiceNumber);
  }, [invoiceNumber]);

  const getInvoice = async (invoiceNumber) => {
    try {
      setLoading(true);
      let response = await GetInvoice(invoiceNumber);
      setInvoiceData(response.results);
    } catch (err) {
      NotificationManager.error('Error getting invoice. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const handleViewOrderClick = (orderNumber) => {
    const orderUrl = `/vlp/lab-orders/${orderNumber}`;

    if (window.labOrderViewWindow && !window.labOrderViewWindow.closed) {
      // If the window is already open and not closed, update its location
      window.labOrderViewWindow.location.href = orderUrl;
    } else {
      // If the window is not open or closed, open a new one and store its reference
      window.labOrderViewWindow = window.open(orderUrl, '_blank', 'resizable=yes,scrollbars=yes');
    }
  };

  const goToNextInvoice = () => {
    const nextInvoiceNumber = parseInt(invoiceNumber) + 1;
    navigate(`/vlp/invoices/${nextInvoiceNumber}`);
  };

  const goToPreviousInvoice = () => {
    const previousInvoiceNumber = parseInt(invoiceNumber) - 1;
    navigate(`/vlp/invoices/${previousInvoiceNumber}`);
  };

  return (
    <div className="vlp-component-container">
      <div
        className="order-navigation-buttons"
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Tooltip title="Move to Previous Invoice">
          <IconButton onClick={goToPreviousInvoice}>
            <ArrowBackRoundedIcon
              style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title="Move to Next Invoice">
          <IconButton onClick={goToNextInvoice}>
            <ArrowForwardRoundedIcon
              style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}
            />
          </IconButton>
        </Tooltip>
      </div>

      <span className="title">Invoice Details # <span style={{ color: 'rgb(25,118,210)', fontWeight: 'bold' }}>{invoiceNumber}</span></span>

      <hr />
      {invoiceData !== null && invoiceData.orderNumber !== null &&
        <span className="">Order # <a style={{ color: 'rgb(25,118,210)', fontWeight: 'bold' }}
          onClick={() => handleViewOrderClick(invoiceData.orderNumber)}
        >{invoiceData.orderNumber}</a></span>
      }
      {invoiceData !== null && <InvoiceOverView invoiceData={invoiceData} />}
      {invoiceData !== null && <InvoiceTransactionsTable transactions={invoiceData.transactions} orderNumber={invoiceData.orderNumber} />}

      <CommonLoader loading={loading} />
    </div>
  );
};

export default ViewInvoice;
